import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const publishedVersionId = (state: RootState) => state.pages.editor.scene.publishedVersionId;

const getPublishedVersionId = createSelector([publishedVersionId], (versionId) => versionId);

export default getPublishedVersionId;
